import { Typography } from '@mui/material';
import * as React from 'react';

export const LogbookPage: React.FunctionComponent = () => {
    return <Typography>Logbook page: Work in progress</Typography>;
};
